import { create } from "zustand";

type ChooseRegionStore = {
  chooseRegion: boolean;
  setChooseRegion: (flag: boolean) => void;
};

export const useChooseRegionStore = create<ChooseRegionStore>((set) => ({
  chooseRegion: false,

  setChooseRegion: (flag) =>
    set(() => ({
      chooseRegion: flag,
    })),
}));
